import { Card, Collapse, FormInstance, Row } from 'antd';
import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import FormInput from 'components/FormInput';
import Title from 'components/Title';
import { useQuery } from 'react-query';
import { getThirdPartyAddresListByTpid } from 'services/thirdParty';

const { Panel } = Collapse;

export type AddressProps = {
  form: FormInstance;
  id: number;
  showAsModal?: boolean;
};

const AddressCardSFS = ({ form, id }: AddressProps) => {
  const { data: Adresses, refetch } = useQuery(
    ['getThirdPartyAddresListAction', { tpid: Number(id) }],
    () =>
      getThirdPartyAddresListByTpid({ tpid: Number(id) }).then(
        (res) => res.list || []
      ),
    { enabled: !!id }
  );

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={['1']}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined
          style={{ fontSize: 24, float: 'left' }}
          rotate={isActive ? 90 : 0}
        />
      )}
      expandIconPosition="left"
    >
      <Panel
        disabled={!id}
        header={<Title level={5} comcode="Main Address"></Title>}
        key="1"
        style={{
          marginBottom: 24,
          overflow: 'hidden',
          background: '#f7f7f7',
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
          border: 10,
          borderRadius: 2,
        }}
      >
        <Card
          style={{
            width: '100%',
            marginBottom: 10,
          }}
          bordered
        >
          <Row gutter={16}>
            <FormInput
              col
              xs={12}
              name="tpmainadrstreet1"
              comcode="tpmainadrstreet1"
            />

            <FormInput
              col
              xs={12}
              name="tpmainadrstreet2"
              comcode="tpmainadrstreet2"
            />
            <FormInput
              col
              xs={12}
              name="tpmainadrzipcode"
              comcode="tpmainadrzipcode"
            />
            <FormInput col xs={12} name="tpmainadrregion" />
            <FormInput col xs={12} name="tpmainadrcountry" />
          </Row>
        </Card>
      </Panel>

      {Adresses?.map((adr, index) => {
        return (
          <Panel
            disabled={!id}
            header={<Title level={5} comcode="all-addresses"></Title>}
            key={adr.tpadrid}
            style={{
              marginBottom: 24,
              overflow: 'hidden',
              background: '#f7f7f7',
              boxShadow:
                'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
              border: 10,
              borderRadius: 2,
            }}
          >
            <Card
              style={{
                width: '100%',
                marginBottom: 10,
              }}
              bordered
            >
              <Row gutter={16}>
                <FormInput
                  col
                  xs={12}
                  name="tpmainadrstreet1"
                  comcode="tpmainadrstreet1"
                />

                <FormInput
                  col
                  xs={12}
                  name="tpmainadrstreet2"
                  comcode="tpmainadrstreet2"
                />
                <FormInput
                  col
                  xs={12}
                  name="tpmainadrzipcode"
                  comcode="tpmainadrzipcode"
                />
                <FormInput
                  col
                  xs={12}
                  name={'tpmainadrregion' + index}
                  initialValue={adr.tpmainadrregionlabel}
                />
                <FormInput
                  col
                  xs={12}
                  name={'tpmainadrcountry' + index}
                  initialValue={adr.tpmainadrcountrylabel}
                />
              </Row>
            </Card>
          </Panel>
        );
      })}
    </Collapse>
  );
};
export default AddressCardSFS;
